/// <amd-module name="Build/Common/Library/SignalRHubProxies" />
import { ConsoleLogEvent } from "Build/Client/Contracts/Build";

import { jqueryShimmed } from "VSS/Features/SignalR/3rdParty/jquery.shimmed";
import * as LoadedHub from "VSS/Features/SignalR/Hub";
import { ISignalRHubProxy } from "VSS/Features/SignalR/HubProxies.types";

import { TimelineRecordUpdate } from "Types";

export interface IBuildDetailHubServer {
    watchBuild: (projectId: string, buildId: number) => Promise<void>;
    watchCollection: () => Promise<void>;
    watchProject: (projectId: string) => Promise<void>;
    stopWatchingBuild: (projectId: string, buildId: number) => Promise<void>;
    stopWatchingCollection: () => Promise<void>;
    stopWatchingProject: (projectId: string) => Promise<void>;
}

export interface IBuildDetailHubClient {
    buildUpdated2: (definitionId: number, buildId: number, definitionScope: string) => void;
    logConsoleLines: (logEvent: ConsoleLogEvent) => void;
    timelineRecordsUpdated: (buildId: number, planId: string, timelineId: string, changeId: number) => void;
    buildArtifactAdded: (buildId: number, artifactName: string) => void;
    stagesUpdated: (buildId: number, timelineId: string, stageUpdates: TimelineRecordUpdate[]) => void;
}

export namespace HubNames {
    export const buildDetailHub = "buildDetailHub";
}

export function getBuildProxyToRegister<C, S>(baseProxy: ISignalRHubProxy<any, any>): ISignalRHubProxy<C, S> {
    const $ = jqueryShimmed;
    baseProxy.server = {
        stopWatchingBuild: function (projectId: string, buildId: number) {
            return baseProxy.invoke.apply(baseProxy, $.merge(["StopWatchingBuild"], $.makeArray(arguments)));
        },

        stopWatchingCollection: function () {
            return baseProxy.invoke.apply(baseProxy, $.merge(["StopWatchingCollection"], $.makeArray(arguments)));
        },

        stopWatchingProject: function (projectId: string) {
            return baseProxy.invoke.apply(baseProxy, $.merge(["StopWatchingProject"], $.makeArray(arguments)));
        },

        watchBuild: function (projectId: string, buildId: number) {
            return baseProxy.invoke.apply(baseProxy, $.merge(["WatchBuild"], $.makeArray(arguments)));
        },

        watchCollection: function () {
            return baseProxy.invoke.apply(baseProxy, $.merge(["WatchCollection"], $.makeArray(arguments)));
        },

        watchProject: function (projectId: string) {
            return baseProxy.invoke.apply(baseProxy, $.merge(["WatchProject"], $.makeArray(arguments)));
        }
    };

    return baseProxy;
}